import { useState } from 'react';
import { translate } from '../../commons/localize';

const initialState = { showModal: false, title: '', message: [] };

function reducer(state, action) {
  switch (action.type) {
    case 'RESET_MODAL_DATA': {
      return initialState;
    }
    case 'TOGGLE':
      return {
        ...state,
        showModal: !state.showModal
      };
    default:
      throw new Error();
  }
}

function useModalControl() {
  const [responseMessage, setResponseMessage] = useState({ title: '', message: '' });

  function handleModalMessages(
    mainTitle,
    mainMessage,
    extraMessage,
    primaryText,
    primaryAction,
    showSecondaryButton,
    secondaryText,
    secondaryAction
  ) {
    const title = translate(mainTitle);
    const message = [];
    message.push(translate(mainMessage));
    if (extraMessage !== '') {
      message.push(extraMessage);
    }

    let primaryBttnAction = () => {};
    if (primaryAction) {
      primaryBttnAction = primaryAction;
    }

    let secondaryBttnAction = () => {};
    if (secondaryAction) {
      secondaryBttnAction = secondaryAction;
    }

    setResponseMessage({
      title,
      message,
      primaryBttnAction,
      primaryBttnText: (typeof primaryText === 'string') ? translate(primaryText) : '',
      showSecondaryBttn: (typeof showSecondaryButton !== 'undefined') ? showSecondaryButton : false,
      secondaryBttnText: (typeof secondaryText === 'string') ? translate(secondaryText) : '',
      secondaryBttnAction
    });
  }

  function resetModalObject() {
    setResponseMessage({ title: '', message: '' });
  }

  return { responseMessage, handleModalMessages, resetModalObject };
}

export { initialState, reducer, useModalControl };
